import { cn } from '@rocco/utils/cn';
import type { UserActiveStatus } from '~/modules/user';
import { StatusIndicator } from './StatusIndicator';

/**
 * An avatar-like component that displays a thumbnail image. This is used instead
 * of the `ParticipantAvatar` component when the chat has a custom thumbnail image.
 * This should have the same size and style as the `ParticipantAvatar` component.
 * @see {@link ParticipantAvatar}
 */
export function ThumbnailAvatar({
    className,
    src,
    activeStatus,
}: {
    className?: string;
    src: string;
    /**
     * If set, shows a status indicator dot next to the avatar.
     */
    activeStatus?: UserActiveStatus;
}) {
    return (
        <span
            className={cn(
                'relative flex aspect-square size-12 rounded-full bg-white transition-[width,height] duration-200 ease-linear will-change-[width,height]',
                className
            )}
        >
            <img
                className="size-full rounded-full object-cover"
                src={src}
                alt="Chat thumbnail"
            />
            {activeStatus && <StatusIndicator status={activeStatus} />}
        </span>
    );
}
